// @flow

import http from "@http";
import config from "@config";
import { all, put, takeEvery, call } from "redux-saga/effects";
import type { Action } from "redux-action";

import serviceActionCreator from "@modules/service/actionCreator";
import {
  GetClientInformation,
  ClientInformationExport,
  ClientInformationExportSuccess,
} from "@modules/recording/constants/actions";
import actionCreator from "@modules/recording/actionCreator";
import { sortToString } from "@transformers/sort";
import { downloadCsvFile } from "@sagas/utils";

type ClientInformationRequest = $Exact<{
  page?: number,
  sort?: *,
}>;

export function* onGetClientInformation({
  payload,
}: Action<ClientInformationRequest>): Generator<*, void, *> {
  try {
    const res = yield call(
      http.get,
      `${config.endpointBaseUrl}api/v1/client-admin/client/clients-information`,
      {
        params: {
          page: (payload || {}).page || 1,
          sort: sortToString((payload || {}).sort || null),
          limit: config.resultsPerPage,
        },
      },
    );

    yield put(actionCreator.GetClientInformationSuccess(res.data));
  } catch (e) {
    yield put(actionCreator.GetClientInformationError((e || {}).response));
  }
}

export function* onClientInformationExport(): Generator<*, void, *> {
  try {
    const res = yield call(
      http.get,
      `${config.endpointBaseUrl}api/v1/client-admin/client/clients-information/export`,
    );

    yield put(actionCreator.ClientInformationExportSuccess(res.data));
  } catch (e) {
    yield put(actionCreator.ClientInformationExportError((e || {}).response));
  }
}

export function* onClientInformationExportSuccess({
  payload,
}: {
  payload: string,
}): Generator<void, void, void> {
  yield downloadCsvFile(payload, "clients-information.csv");
}

export function* ClientInformationSaga(): Generator<*, void, void> {
  yield all([
    takeEvery(GetClientInformation, onGetClientInformation),
    takeEvery(ClientInformationExport, onClientInformationExport),
    takeEvery(ClientInformationExportSuccess, onClientInformationExportSuccess),
  ]);
}

export default ClientInformationSaga;
